const BlogData = [
  {
    id: 1,
    title: "Let's Learn: Kids Learning App (Part 1)",
    description: "Interactive app where kids learn reading, writing, drawing, and speaking skills.",
    date: "March 2026",
    image: require("../assets/images/blog/letslearn.png"),
    video: require("../assets/videos/letslearnv1.mp4"),
    content: `Let's Learn engages children with interactive activities.
Kids can read, write, draw, and develop speaking skills in a fun way.`
  },
  {
    id: 2,
    title: "Snake & Ladder: Fun Educational Game",
    description: "Digital version of Snake & Ladder for kids with online and local multiplayer modes.",
    date: "March 2026",
    image: require("../assets/images/blog/snake_and_ladder.png"),
     video: require("../assets/videos/snakeladderv1.mp4"),
    content: `This game encourages strategic thinking, patience, and friendly competition.
Kids can play locally or online with friends or AI bots.`
  },
  {
    id: 3,
    title: "Let's Learn: Kids Learning App (Part 2)",
    description: "Interactive app where kids learn reading, writing, drawing, and speaking skills.",
    date: "March 2026",
    image: require("../assets/images/blog/letslearn.png"),
    video: require("../assets/videos/letslearnv2.mp4"),
    content: `Let's Learn engages children with interactive activities.
Kids can read, write, draw, and develop speaking skills in a fun way.`
  },
  {
    id: 4,
    title: "FredHour CRM: Education Consultancy Management",
    description: "Discover how CRM systems help manage leads, tasks, and clients efficiently.",
    date: "March 2026",
    image: require("../assets/images/blog/crm.png"),
    content: `FredHour CRM organizes leads, student profiles, tasks, and documents in a single platform.
It improves efficiency and communication for consultancies.`
  },
  {
    id: 5,
    title: "Revive: Rehabilitation Center Management",
    description: "Manage rehab residents, staff, accounts, and schedules efficiently with Revive.",
    date: "March 2026",
    image: require("../assets/images/blog/revive.png"),
    content: `Revive is designed for rehabilitation centers to track residents, petty cash,
tiffin schedules, and daily headcounts efficiently.`
  }
];

export default BlogData;